export default "__VITE_ASSET__z9ki5S$k__"